import {BaseModel} from './base.model';
import { InstituteTypeModel } from './institute-type.model';
import { DepartamentModel } from './departament.model';

export class InstituteModel extends BaseModel {

    name: string;
    city: string;

    institute_type_id: number;

    emails: any[];
    dyn_list_items: any[];

    institute_mails: any[];
    institute_dyn_list_items: any[];

    institute_type: InstituteTypeModel;
    departaments: DepartamentModel[];

    static validate(institute: InstituteModel): boolean {
        return !!(institute.name && institute.institute_type_id);
    }

    constructor(institute?: InstituteModel) {
        super();

        this.name = institute ? institute.name || null : null;
        this.city = institute ? institute.city || null : null;

        this.institute_type_id= institute ? institute.institute_type_id || null : null

        this.institute_type = institute ? institute.institute_type || new InstituteTypeModel() : new InstituteTypeModel();
        this.departaments = institute ? institute.departaments || [] : [];

        this.emails = institute ? institute.emails || [] : [];
        this.dyn_list_items = institute ? institute.dyn_list_items || [] : [];

        this.institute_mails = institute ? institute.institute_mails || [] : [];
        this.institute_dyn_list_items = institute ? institute.institute_dyn_list_items || [] : [];
    }
}



// WEBPACK FOOTER //
// C:/Users/Emanuel/Documents/EasyCheck/easy-check-front-web/src/app/shared/model/institute.model.ts